import { render, staticRenderFns } from "./pickupDetail.vue?vue&type=template&id=1b6268d4&scoped=true&"
import script from "./pickupDetail.js?vue&type=script&lang=js&"
export * from "./pickupDetail.js?vue&type=script&lang=js&"
import style1 from "./pickupDetail.vue?vue&type=style&index=1&id=1b6268d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6268d4",
  null
  
)

export default component.exports